module.exports = __webpack_public_path__ + "static/media/energyCComplex.83ccb064.png";